import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=1fe82be8&scoped=true&"
import script from "./Downloads.vue?vue&type=script&lang=js&"
export * from "./Downloads.vue?vue&type=script&lang=js&"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=1fe82be8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe82be8",
  null
  
)

export default component.exports